import url from './urls'

const state = {
  categorys: null,
  committees: null,
  chairmanBios: null,
  isLoading: false
}

const mutations = {
  GETCATEGORY (state) {
    state.isLoading = true

    fetch(url.about.committeeCategory)
      .then(response => response.json())
      .then(data => {
        state.isLoading = false
        state.categorys = data
      })
      .catch(err => {
        state.isLoading = false
        console.error(err)
      })
  },

  GETCOMMITTEE (state, id) {
    state.isLoading = true

    fetch(url.about.committee + id)
      .then(response => response.json())
      .then(data => {
        state.isLoading = false
        state.committees = data
      })
      .catch(err => {
        state.isLoading = false
        console.error(err)
      })
  },

  GETCHAIRMANBIO (state) {
    state.isLoading = true

    fetch(url.about.chairmanBiography)
      .then(response => response.json())
      .then(data => {
        setTimeout(() => {
          state.isLoading = false
        }, 1000)

        state.chairmanBios = data
      })
      .catch(err => {
        state.isLoading = false
        console.error(err)
      })
  }
}

const actions = {
  getCategory ({ commit }) {
    commit('GETCATEGORY')
  },

  getCommittee ({ commit }, id) {
    commit('GETCOMMITTEE', id)
  },

  getChairmanBio ({ commit }) {
    commit('GETCHAIRMANBIO')
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
